export const HOME = '/';
export const FEATURES = '/features';
export const PRIVACYPOLICY = '/privacypolicy';
